import { render, staticRenderFns } from "./PreshippingTableNew.vue?vue&type=template&id=5495bdc0"
import script from "./PreshippingTableNew.vue?vue&type=script&lang=js"
export * from "./PreshippingTableNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports